import { render, staticRenderFns } from "./RsMain.vue?vue&type=template&id=56d3cc9e&scoped=true&"
import script from "./RsMain.vue?vue&type=script&lang=js&"
export * from "./RsMain.vue?vue&type=script&lang=js&"
import style0 from "./RsMain.vue?vue&type=style&index=0&id=56d3cc9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d3cc9e",
  null
  
)

export default component.exports